import { DictionaryHelper } from "src/app/helpers/dictionary-helper";
import { VuPaymentType } from "../../payment/models/vu-payment-type.enum";

export class VuConfiguration {

  private _internalProperties: any;
  private _internalPropertiesDictionaryHelper: DictionaryHelper;

  get properties(): any {
    return this._internalProperties;
  }

  set properties(value) {
    this._internalProperties = value;
    this._internalPropertiesDictionaryHelper = new DictionaryHelper(this._internalProperties);
  }

  get propertiesHelper(): DictionaryHelper {
    return this._internalPropertiesDictionaryHelper;
  }

  get additionalPropertiesHelper(): DictionaryHelper {
    if (!this.propertiesHelper) {
      return null;
    }
    return this.propertiesHelper.getPropertyHelper('additionalProperties');
  }

  get originalPropertiesHelper(): DictionaryHelper {
    if (!this.propertiesHelper) {
      return null;
    }
    return this.propertiesHelper.getPropertyHelper('properties');
  }

  get originalConfigurationHelper(): DictionaryHelper {
    if (!this.originalPropertiesHelper) {
      return null;
    }
    return this.originalPropertiesHelper.getPropertyHelper('configuration');
  }

  get vuPaymentMethods(): VuPaymentType[] {
    const result = [];
    if (!this.propertiesHelper || !this.additionalPropertiesHelper) {
      return result;
    }

    const isSmartHopperPresentInMinConfiguration = this.propertiesHelper.getBoolean('isSmartHopperPresentInMinConfiguration');
    const isCashPaymentAvailable = this.additionalPropertiesHelper.getBoolean('is_cash_payment_available');
    const isCreditCardPaymentAvailable = this.additionalPropertiesHelper.getBoolean('is_credit_card_payment_available');
    if (isCashPaymentAvailable) {
      if (isSmartHopperPresentInMinConfiguration) {
        result.push(VuPaymentType.Cash);
      } else {
        result.push(VuPaymentType.CashBillsOnly);
      }
    }
    if (isCreditCardPaymentAvailable) {
      result.push(VuPaymentType.Card);
    }
    return result;
  }

  static createFromAny(data: any): VuConfiguration {
    if (!data) {
      return null;
    }

    const vUConfiguration = new VuConfiguration();
    vUConfiguration.properties = data;
    return vUConfiguration;
  }

  get stockLocationsIds(): number[] {
    return this.originalConfigurationHelper?.getNumberArray('stock_locations_ids');
  }
}
